import script from "./DisdiDetailTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisdiDetailTab.vue?vue&type=script&setup=true&lang=ts"

import "./DisdiDetailTab.vue?vue&type=style&index=0&id=1b4a1076&scoped=true&lang=css"

import exportComponent from "C:\\Users\\digi_aj\\source\\repos\\1ANAB_Vue_Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b4a1076"]])

export default __exports__